module.exports = __webpack_public_path__ + "img/bottom_icon4.4d5f89ae_4d5f89aec157208fab9c236942382d97.4d5f89ae.png";